import script from "./MainImageGen.vue?vue&type=script&setup=true&lang=js"
export * from "./MainImageGen.vue?vue&type=script&setup=true&lang=js"

import "./MainImageGen.vue?vue&type=style&index=0&id=ed3d6c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed3d6c0e"]])

export default __exports__